import {
    Star,
    MessageSquare,
    UtensilsCrossed,
    Store,
    CalendarDays,
} from "lucide-react";

import "./ReviewsCard.css";

function ReviewsCard({ reviews }) {

    if (!reviews || reviews.length === 0) {

        return (

            <div className="customer-card">

                <h2 className="customer-card-title">

                    Reviews

                </h2>

                <p className="customer-empty">

                    No reviews available.

                </p>

            </div>

        );

    }

    return (

        <div className="customer-card">

            <h2 className="customer-card-title">

                Reviews

            </h2>

            <div className="customer-reviews-list">

                {reviews.map((review) => (

                    <div
                        key={review._id}
                        className="customer-review-item"
                    >

                        <div className="customer-review-header">

                            <div>

                                <h3>

                                    <UtensilsCrossed size={16} />

                                    {" "}
                                    {review.food?.foodName || "Food"}

                                </h3>

                                <p>

                                    <Store size={15} />

                                    {" "}
                                    {review.provider?.business?.businessName || "Provider"}

                                </p>

                            </div>

                            <div className="customer-rating">

                                <Star
                                    size={16}
                                    fill="currentColor"
                                />

                                <span>

                                    {review.rating}

                                </span>

                            </div>

                        </div>

                        <div className="customer-review-body">

                            <p>

                                <MessageSquare size={15} />

                                {" "}
                                {review.comment || "No comment"}

                            </p>

                        </div>

                        <div className="customer-review-footer">

                            <CalendarDays size={15} />

                            {" "}

                            {new Date(review.createdAt).toLocaleDateString("en-IN")}

                        </div>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default ReviewsCard;